export const categoryConstants = {
	GET_ALL_CATEGORIES_REQUEST: 'GET_ALL_CATEGORIES_REQUEST',
	GET_ALL_CATEGORIES_SUCCESS: 'GET_ALL_CATEGORIES_SUCCESS',
	ADD_NEW_CATEGORIES_REQUEST: 'ADD_NEW_CATEGORIES_REQUEST',
	ADD_NEW_CATEGORIES_SUCCESS: 'ADD_NEW_CATEGORIES_SUCCESS',
	ADD_NEW_CATEGORIES_FAILURE: 'ADD_NEW_CATEGORIES_FAILURE'
};

export const productConstants = {
	GET_ALL_PRODUCT_REQUEST: 'GET_ALL_PRODUCT_REQUEST',
	GET_ALL_PRODUCT_SUCCESS: 'GET_ALL_PRODUCT_SUCCESS',
	GET_ALL_PRODUCT_FAILURE: 'GET_ALL_PRODUCT_FAILURE',

	GET_PRODUCTS_BY_SLUG_REQUEST: 'GET_PRODUCTS_BY_SLUG_REQUEST',
	GET_PRODUCTS_BY_SLUG_SUCCESS: 'GET_PRODUCTS_BY_SLUG_SUCCESS',
	GET_PRODUCTS_BY_SLUG_FAILURE: 'GET_PRODUCTS_BY_SLUG_FAILURE',

	GET_PRODUCT_DETAILS_BY_ID_REQUEST: 'GET_PRODUCT_DETAILS_BY_ID_REQUEST',
	GET_PRODUCT_DETAILS_BY_ID_SUCCESS: 'GET_PRODUCT_DETAILS_BY_ID_SUCCESS',
	GET_PRODUCT_DETAILS_BY_ID_FAILURE: 'GET_PRODUCT_DETAILS_BY_ID_FAILURE',

	GET_PRODUCT_PAGE_REQUEST: 'GET_PRODUCT_PAGE_REQUEST',
	GET_PRODUCT_PAGE_SUCCESS: 'GET_PRODUCT_PAGE_SUCCESS',
	GET_PRODUCT_PAGE_FAILURE: 'GET_PRODUCT_PAGE_FAILURE'
};

export const authConstants = {
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_FAILURE: 'LOGIN_FAILURE',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',

	SIGNUP_REQUEST: 'SIGNUP_REQUEST',
	SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
	SIGNUP_FAILURE: 'SIGNUP_FAILURE',

	LOGOUT_REQUEST: 'LOGOUT_REQUEST',
	LOGOUT_FAILURE: 'LOGOUT_FAILURE',
	LOGOUT_SUCCESS: 'LOGOUT_SUCCESS'
};

export const cartConstants = {
	ADD_TO_CART_REQUEST: 'ADD_TO_CART_REQUEST',
	ADD_TO_CART_SUCCESS: 'ADD_TO_CART_SUCCESS',
	ADD_TO_CART_FAILURE: 'ADD_TO_CART_FAILURE',

	REMOVE_CART_ITEM_REQUEST: 'REMOVE_CART_ITEM_REQUEST',
	REMOVE_CART_ITEM_SUCCESS: 'REMOVE_CART_ITEM_SUCCESS',
	REMOVE_CART_ITEM_FAILURE: 'REMOVE_CART_ITEM_FAILURE',
	RESET_CART: 'RESET_CART'
};

export const userConstants = {
	GET_USER_ADDRESS_REQUEST: 'GET_USER_ADDRESS_REQUEST',
	GET_USER_ADDRESS_SUCCESS: 'GET_USER_ADDRESS_SUCCESS',
	GET_USER_ADDRESS_FAILURE: 'GET_USER_ADDRESS_FAILURE',

	ADD_USER_ADDRESS_REQUEST: 'ADD_USER_ADDRESS_REQUEST',
	ADD_USER_ADDRESS_SUCCESS: 'ADD_USER_ADDRESS_SUCCESS',
	ADD_USER_ADDRESS_FAILURE: 'ADD_USER_ADDRESS_FAILURE',

	ADD_USER_ORDER_REQUEST: 'ADD_USER_ORDER_REQUEST',
	ADD_USER_ORDER_SUCCESS: 'ADD_USER_ORDER_SUCCESS',
	ADD_USER_ORDER_FAILURE: 'ADD_USER_ORDER_FAILURE',

	GET_USER_ORDER_REQUEST: 'GET_USER_ORDER_REQUEST',
	GET_USER_ORDER_SUCCESS: 'GET_USER_ORDER_SUCCESS',
	GET_USER_ORDER_FAILURE: 'GET_USER_ORDER_FAILURE',

	GET_USER_ORDER_DETAILS_REQUEST: 'GET_USER_ORDER_DETAILS_REQUEST',
	GET_USER_ORDER_DETAILS_SUCCESS: 'GET_USER_ORDER_DETAILS_SUCCESS',
	GET_USER_ORDER_DETAILS_FAILURE: 'GET_USER_ORDER_DETAILS_FAILURE'
};

export const orderConstants = {
	GET_CUSTOMER_ORDER_REQUEST: 'GET_CUSTOMER_ORDER_REQUEST',
	GET_CUSTOMER_ORDER_SUCCESS: 'GET_CUSTOMER_ORDER_SUCCESS',
	GET_CUSTOMER_ORDER_FAILURE: 'GET_CUSTOMER_ORDER_FAILURE',

	GET_USER_ADDRESSES_REQUEST: 'GET_USER_ADDRESSES_REQUEST',
	GET_USER_ADDRESSES_SUCCESS: 'GET_USER_ADDRESSES_SUCCESS',
	GET_USER_ADDRESSES_FAILURE: 'GET_USER_ADDRESSES_FAILURE',

	UPDATE_CUSTOMER_ORDER_REQUEST: 'UPDATE_CUSTOMER_ORDER_REQUEST',
	UPDATE_CUSTOMER_ORDER_SUCCESS: 'UPDATE_CUSTOMER_ORDER_SUCCESS',
	UPDATE_CUSTOMER_ORDER_FAILURE: 'UPDATE_CUSTOMER_ORDER_FAILURE'
};